export function formatAndCapitalizeString(str: string) {
  const formatted = str.replace(/-/g, " ");
  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
}
